import { HttpService } from "@/core";
import {
  ProjectTypePageReq,
  ProjectTypePageResp,
  ProjectTypeSimpleListResp,
  ProjectTypeDetailResp,
  ProjectTypeReq,
} from "./project-type.interface";

export class ProjectTypeService {
  static usePageApi() {
    const api = (params: ProjectTypePageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/project_type/page",
        params,
      });
    return HttpService.usePagination<ProjectTypePageResp>(api);
  }

  static useImportApi() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/project_type/import",
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useSimpleListApi() {
    const api = () =>
      HttpService.axios({
        method: "GET",
        url: "/project_type/simple/list",
      });
    return HttpService.useRequest<ProjectTypeSimpleListResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/project_type/${id}`,
      });
    return HttpService.useRequest<ProjectTypeDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: ProjectTypeReq) =>
      HttpService.axios({
        method: "POST",
        url: "/project_type",
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useEditApi() {
    const api = (id: string, data: ProjectTypeReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/project_type/${id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/project_type/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static useUploadProjectType() {
    const api = (url) =>
      HttpService.axios({
        url: "/project_type/importBatchCheck",
        data: {
          url,
        },
        method: "post",
      });
    return HttpService.useRequest<any>(api);
  }

  static useFinishUpload() {
    const api = (data) =>
      HttpService.axios({
        url: "/project_type/importBatchAdd",
        data: {
          projectTypeAddAReqs: data,
        },
        method: "post",
      });
    return HttpService.useRequest<void>(api);
  }
}
